// extracted by mini-css-extract-plugin
export var tosLink = "_7l-0";